// @flow
import type { Firestore } from '../types/firebase';
import _createModel from './_model';
import type { Config } from './_model';

export default (firestore: Firestore, config?: Config) => _createModel(firestore, {
    collection: 'messages'
}, config);